export const taxesOptions = {
  NON_TAXABLE: 'Non-Taxable',
  TAXABLE: 'Tax Added On',
  TAX_INCLUSIVE: 'Tax Inclusive',
  NO_TAX_UPDATES: 'No Tax Updates',
}

export const discountableOptions = {
  ALL_DISCOUNTABLE: 'All Discountable',
  DONT_ALL_DISCOUNTABLE: 'Do not all discountable',
  NO_DISCOUNTS_UPDATES: 'No Discounts Updates',
}
